module.exports = __webpack_public_path__ + "img/9a.9e87f86e.jpg";